import { render } from "./ActivityFilter.vue?vue&type=template&id=153d9f4e&scoped=true"
import script from "./ActivityFilter.vue?vue&type=script&lang=js"
export * from "./ActivityFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153d9f4e"]])

export default __exports__